<div class="menu-container"
     [style]="setBackground()"
     [ngClass]="{'menu-container-background' : isBackground }" >
    <div class="menu-icons-container">
        <div>
            <div class="menu-icons">
                <div class="menu-icon-el" style="width: 40px; height: 40px">
                    <a target="_blank" href="https://vk.com/szd_official">
                        <app-icon [icon]="Icons.vkWhite" />
                    </a>
                </div>
                <div class="menu-icon-el" style="width: 40px; height: 40px; margin-left: 0.5rem">
                    <a target="_blank" href="https://t.me/szdrzd">
                        <app-icon [icon]="Icons.tgWhite"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="menu-items-container">
        <div>
            <div *ngFor="let item of elements; index as i">
                <div class="menu-items-el"
                     [ngClass]="{'menu-items-el-last' : i == elements.length - 1}"
                     (mouseenter)="onMouseEnter(item.bg ?? '')"
                     (mouseleave)="onMouseLeave()"
                     (click)="navigate(item)">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="menu-mob-container">
    <div *ngFor="let item of elements; index as i">
        <div class="menu-items-el"
             [ngClass]="{'menu-items-el-last' : i == elements.length - 1}"
             (mouseenter)="onMouseEnter(item.bg ?? '')"
             (mouseleave)="onMouseLeave()"
             (click)="navigate(item)">
            {{ item.title }}
        </div>
    </div>
    <div class="menu-icons">
        <div class="menu-icon-el" style="width: 40px; height: 40px">
            <a target="_blank" href="https://vk.com/szd_official">
                <app-icon [icon]="Icons.vkWhite" />
            </a>
        </div>
        <div class="menu-icon-el" style="width: 40px; height: 40px; margin-left: 0.5rem">
            <a target="_blank" href="https://t.me/szdrzd">
                <app-icon [icon]="Icons.tgWhite"/>
            </a>
        </div>
    </div>
</div>
